import { Constants } from 'src/constants';
import { DocumentObject } from 'src/type/document-object';
import { downloadFile } from 'src/util/download-image';
import { getFileNameFromUrl } from 'src/util/file';
import { Typography } from '../common/Typography';
import ColorSVGIcon from '../icon/ColorSVGIcon';

interface DocumentCardProps {
  id: number;
  documentObjet: DocumentObject;
  isDownload?: boolean;
  onDeleteClick?: (key: number) => void;
}

export function DocumentCard({ id, documentObjet, isDownload = false, onDeleteClick }: DocumentCardProps) {
  if (documentObjet.isDelete) {
    return null;
  }

  const fileName =
    typeof documentObjet.document === 'string'
      ? getFileNameFromUrl(documentObjet.document)
      : documentObjet.document.name;

  return (
    <div
      className="flex cursor-pointer items-center justify-center gap-2 rounded-lg bg-primary-gray-50 px-4 py-[9px]"
      onClick={() => isDownload && downloadFile(`${Constants.imageUrl}${documentObjet.document}`, fileName)}
    >
      <Typography variant="body2" className="font-medium text-primary-gray-700">
        {fileName}
      </Typography>
      {onDeleteClick && (
        <div onClick={() => onDeleteClick(id)}>
          <ColorSVGIcon.Close className="cursor-pointer" color="dimmed" size={24} />
        </div>
      )}
    </div>
  );
}
